<template>
  <div class="row">
    <div class="col-8">
      <h3>Nested draggable</h3>
      <nested-draggable :tasks="list" />
    </div>

    <rawDisplayer class="col-3" :value="list" title="List" />
  </div>
</template>

<script>
import nestedDraggable from '../infra/nested'
import rawDisplayer from '../infra/rawDisplayer'
export default {
  name: 'nested-example',
  display: 'Nested',
  order: 15,
  components: {
    nestedDraggable, rawDisplayer
  },
  data () {
    return {
      list: [
        {
          name: 'task 1',
          tasks: []
        },
        {
          name: 'task 2',
          tasks: []
        },
        {
          name: 'task 3',
          tasks: [
            {
              name: 'task 10'
            }
          ]
        },
        {
          name: 'task 4',
          tasks: []
        },
        {
          name: 'task 5',
          tasks: []
        },
        {
          name: 'task 6',
          tasks: []
        },
        {
          name: 'task 7',
          tasks: []
        },
        {
          name: 'task 8',
          tasks: []
        },
        {
          name: 'task 9',
          tasks: []
        }
      ]
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/nested/nested-example.vue